import { Controller } from "stimulus";
import Tribute from "tributejs";
import Trix from "trix";

export default class extends Controller {
  static targets = [ "field" ]

  connect() {
    this.editor = this.fieldTarget.editor
    this.initializeTribute()
    this.initializeTributeForClients()
    this.initializeTributeForPets()
  }

  disconnect() {
    this.tribute.detach(this.fieldTarget)
  }

  initializeTribute() {
    this.tribute = new Tribute({
      allowSpaces: true,
      lookup: 'name',
      values: this.fetchUsers,
    })
    this.tribute.attach(this.fieldTarget)
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this)
    this.fieldTarget.addEventListener("tribute-replaced", this.replaced)
  }

  initializeTributeForClients() {
    this.tribute = new Tribute({
      trigger: '#',
      allowSpaces: true,
      lookup: 'name',
      values: this.fetchClients,
    })
    this.tribute.attach(this.fieldTarget)
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this)
    this.fieldTarget.addEventListener("tribute-replaced", this.replaced)
  }

  initializeTributeForPets() {
    this.tribute = new Tribute({
      trigger: '##',
      allowSpaces: true,
      lookup: 'name',
      values: this.fetchPets,
    })
    this.tribute.attach(this.fieldTarget)
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this)
    this.fieldTarget.addEventListener("tribute-replaced", this.replaced)
  }


  fetchUsers(text, callback) {
    fetch("/business/mentions/users.json?query="+text)
      .then(response => response.json())
      .then(users => callback(users))
      .catch(error => callback([]))
  }

  fetchClients(text, callback) {
    fetch("/business/mentions/clients.json?query="+text)
      .then(response => response.json())
      .then(clients => callback(clients))
      .catch(error => callback([]))
  }

  fetchPets(text, callback) {
    fetch("/business/mentions/pets.json?query="+text)
      .then(response => response.json())
      .then(pets => callback(pets))
      .catch(error => callback([]))
  }

  _pasteHtml(html, startPos, endPos) {
    let range = this.editor.getSelectedRange()
    let position = range[0]
    let length = endPos - startPos

    this.editor.setSelectedRange([position - length, position])
    this.editor.deleteInDirection("backward")
  }

  replaced(e) {
    let mention = e.detail.item.original
    let attachment = new Trix.Attachment({
      sgid: mention.sgid,
      content: mention.content
    })
    this.editor.insertAttachment(attachment)
    this.editor.insertString(" ")
  }
}